import { Component } from '@angular/core';

@Component({
  selector: 'app-notifications',
  template: `
    <div class="col-sm-10 offset-sm-1 col-md-9 offset-md-2 col-lg-7 offset-lg-4 col-xl-7 offset-xl-4 col-xxl-9 offset-xxl-3 mt-3">
      <div class="row mb-4">
        <div class="col-sm-5 offset-sm-1 col-md-5 offset-md-0">
          <h1>Notificaciones</h1>
          <!-- p>Consulta los condominios.</!-->
        </div>
        <div class="col-sm-6 col-md-7 mt-4 text-end">
        <!-- button class="btn btn-outline-primary btn-lg rounded-5 shadow border border-3 border-primary" *ngIf="permissions?.modules.admin.settlements.write" routerLink="/condominios/create/condominio">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>
          Agregar
        </!-->
          <!-- button class="btn btn-primary btn-lg rounded-5 ms-3" routerLink="/bills/new">Crear recibo</!-->
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class NotificationsComponent {

}
